import {
 JSX
} from 'react';
import {
 OpCode,OpCodeType
} from '../types/storyBuilder.types';
import {
 Table, FormInput, BarChartIcon, Code2, Layout
} from 'lucide-react';

export const getOpCodeIcon = (type: OpCodeType): JSX.Element => {
  switch (type) {
    case 'table':
      return <Table className="h-4 w-4" />;
    case 'form':
      return <FormInput className="h-4 w-4" />;
    case 'chart':
      return <BarChartIcon className="h-4 w-4" />;
    default:
      return <Code2 className="h-4 w-4" />;
  }
};

export const renderSectionPreview = (opCode: OpCode): JSX.Element => {
  switch (opCode.type) {
    case 'table':
      return (
          <div className="bg-card rounded-lg p-6 border-2">
              <div className="space-y-4">
                  <div className="h-8 bg-muted rounded w-full" />
                  <div className="space-y-2">
                      {[1, 2, 3].map((row) => (
                          <div key={row} className="flex space-x-4">
                              {[1, 2, 3].map((col) => (
                                  <div key={col} className="h-8 bg-muted rounded flex-1" />
                  ))}
                          </div>
              ))}
                  </div>
              </div>
          </div>
      );
    case 'form':
      return (
          <div className="bg-card rounded-lg p-6 border-2">
              <div className="space-y-4">
                  <div className="h-8 bg-muted rounded w-1/2" />
                  <div className="space-y-2">
                      {[1, 2, 3].map((field) => (
                          <div key={field} className="space-y-1">
                              <div className="h-4 bg-muted rounded w-1/4" />
                              <div className="h-10 bg-muted rounded w-full" />
                          </div>
              ))}
                  </div>
                  <div className="h-10 bg-primary/20 rounded w-1/4" />
              </div>
          </div>
      );
    default:
      return (
          <div className="bg-card rounded-lg p-6 border-2">
              <div className="space-y-4">
                  <div className="h-8 bg-muted rounded w-1/2" />
                  <div className="h-32 bg-muted rounded flex items-center justify-center">
                      <Layout className="h-12 w-12 text-muted-foreground" />
                  </div>
              </div>
          </div>
      );
  }
};
